export var RoleEnum = {
    LOGGED_USER: "LoggedUser",
    SUPERUSER: "Superuser",
    SYSTEM: "System",
    ADMIN_LEGAL_DEPOSITS: "AdminLegalDeposits",
    LIBRARIAN_LEGAL_DEPOSITS: "LibrarianLegalDeposits",
    LIBRARIAN_LEGAL_DEPOSITS_MONOGRAPHS: "LibrarianLegalDepositsMonographs",
    LIBRARIAN_LEGAL_DEPOSITS_PERIODICALS: "LibrarianLegalDepositsPeriodicals",
};
